import { estHex } from '@taki/data-model';
import type { Couleur } from '@taki/data-model';

/**
 * LE RENDU D'UNE COULEUR D'OPTION (`Couleur`, packages/data-model/src/couleurs.ts).
 *
 * Une clef de la grille devient une VARIABLE CSS (`tokens.css`), qui suit le
 * theme ; un hex est rendu tel quel. Les quatre tons d'avant gardent EXACTEMENT
 * leur token d'origine (les memes que les classes `bg-ink-400`, `bg-accent-dot`,
 * `bg-success`, `bg-danger` qu'ils portaient) : une config existante s'affiche
 * a l'identique. Absente : comme `neutral`.
 *
 * Les vues posent ces valeurs en `style` (`backgroundColor`, `borderColor`),
 * jamais en classe Tailwind : un hex choisi par un client n'a pas de classe.
 */
const POINTS_D_ORIGINE: Readonly<Record<string, string>> = {
  neutral: 'var(--ink-400)',
  accent: 'var(--accent-dot)',
  success: 'var(--success)',
  danger: 'var(--danger)',
};

/** La couleur d'un POINT (pastille, puce de statut, colonne de kanban). */
export function couleurCss(c: Couleur | undefined): string {
  if (c === undefined) return POINTS_D_ORIGINE['neutral']!;
  if (estHex(c)) return c;
  return POINTS_D_ORIGINE[c] ?? `var(--couleur-${c})`;
}

/** La couleur d'un BORD : l'accent a son token de bordure, le reste reprend le point. */
export function couleurDeBord(c: Couleur | undefined): string {
  return c === 'accent' ? 'var(--accent-border)' : couleurCss(c);
}

/** Un APLAT clair de la couleur (fond de carte, de ligne) : l'accent a sa teinte, le reste est melange au blanc de surface. */
export function teinteDe(c: Couleur | undefined): string {
  return c === 'accent' ? 'var(--accent-tint)' : `color-mix(in srgb, ${couleurCss(c)} 14%, var(--surface))`;
}
